import { lazy } from 'react';

import { LayoutType, PageType } from '@shared/constants/constants';
import {
  ACTION_BACK_PATH,
  MEDREFILL_HISTORY_DETAILS_PATH,
  MEDREFILL_HISTORY_ORDERCANCEL_SUCCESSFUL_REQUEST_PATH,
  MEDREFILL_HISTORY_ORDERCANCEL_UNSUCCESSFUL_REQUEST_PATH,
  MEDREFILL_HISTORY_PATH,
} from '@shared/constants/paths';
import { SERVICE_CATALOG_CODE } from '@shared/constants/serviceCatalog';
import type { RouteConfig } from '@shared/types/common.types';

const MedRefillHistoryPage = lazy(() => import('./pages/MedRefillHistoryPage/MedRefillHistoryPage'));
const MedRefillHistoryPastOrderDetailsPage = lazy(
  () => import('./pages/MedRefillHistoryPastOrderDetailsPage/MedRefillHistoryPastOrderDetailsPage')
);
const SuccessfulMedRefillCancelRequestPage = lazy(
  () => import('./pages/SuccessfulMedRefillCancelRequestPage/SuccessfulMedRefillCancelRequestPage')
);
const UnsuccessfulMedRefillCancelRequestPage = lazy(
  () => import('./pages/UnsucessfulMedRefillCancelRequestPage/UnsucessfulMedRefillCancelRequestPage')
);

export const MEDREFILL_HISTORY_ROUTES: RouteConfig[] = [
  {
    actionUrl: ACTION_BACK_PATH,
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.SHARED],
    component: () => <MedRefillHistoryPage />,
    displayTitle: () => 'Medication Refill History',
    pageType: PageType.PRIVATE,
    path: MEDREFILL_HISTORY_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.medicationRefillHistory,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.SHARED],
    component: () => <MedRefillHistoryPastOrderDetailsPage />,
    displayTitle: () => 'Past Request Details',
    pageType: PageType.PRIVATE,
    path: MEDREFILL_HISTORY_DETAILS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.medicationRefillHistory,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.SHARED],
    component: () => <SuccessfulMedRefillCancelRequestPage />,
    displayTitle: () => 'Medication Refill History',
    path: MEDREFILL_HISTORY_ORDERCANCEL_SUCCESSFUL_REQUEST_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.medicationRefillHistory,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.SHARED],
    component: () => <UnsuccessfulMedRefillCancelRequestPage />,
    displayTitle: () => 'Medication Refill History',
    path: MEDREFILL_HISTORY_ORDERCANCEL_UNSUCCESSFUL_REQUEST_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.medicationRefillHistory,
  },
];
